<template>
  <button type="button" class="v-video-control" @click="play">
    <svg v-if="videoState.playing" role="presentation" focusable="false">
      <path
        d="M6 1H3c-.6 0-1 .4-1 1v14c0 .6.4 1 1 1h3c.6 0 1-.4 1-1V2c0-.6-.4-1-1-1zM12 1c-.6 0-1 .4-1 1v14c0 .6.4 1 1 1h3c.6 0 1-.4 1-1V2c0-.6-.4-1-1-1h-3z"
      ></path>
    </svg>
    <svg v-if="!videoState.playing" role="presentation" focusable="false">
      <path
        d="M15.562 8.1L3.87.225C3.052-.337 2 .225 2 1.125v15.75c0 .9 1.052 1.462 1.87.9L15.563 9.9c.584-.45.584-1.35 0-1.8z"
      ></path>
    </svg>
  </button>
</template>

<script>
export default {
  inject: ["eventBus"],
  props: {
    videoState: {
      type: Object
    }
  },
  data() {
    return {};
  },
  methods: {
    play() {
      this.eventBus.$emit("video.play");
    }
  }
};
</script>
